unit View.UserProfile;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, WEBLib.DBCtrls, XData.Web.Client,
  WEBLib.WebCtrls, System.StrUtils, UUtils;

type
  TFViewUserProfile = class(TForm)
    WebLabel1: TLabel;
    cdsUsuarios: TXDataWebDataSet;
    dtsUsuarios: TDataSource;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbemail: TLabel;
    edemail: TDBEdit;
    lbultimo_acesso: TLabel;
    edultimo_acesso: TDBEdit;
    edinclusao: TDBEdit;
    lbinclusao: TLabel;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbperfil: TLabel;
    edperfil: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    cdsUsuariosid: TIntegerField;
    cdsUsuariosperfil: TIntegerField;
    cdsUsuariosperfil_acesso: TStringField;
    cdsUsuariosnome: TStringField;
    cdsUsuariosemail: TStringField;
    cdsUsuariosstatus: TIntegerField;
    cdsUsuariosultimo_acesso: TDateTimeField;
    cdsUsuariosinclusao: TDateTimeField;
    cdsUsuariosalteracao: TDateTimeField;
    edtSenhaAtual: TEdit;
    edtNovaSenha: TEdit;
    edtConfirmarSenha: TEdit;
    lblSenhaAtual: TLabel;
    lblNovaSenha: TLabel;
    lblConfirmarSenha: TLabel;
    btnAlterarSenha: TButton;
    XDataClientAlterarSenha: TXDataWebClient;
    btnChamarModalSenha: TButton;
    divCheckBoxServidores: THTMLDiv;
    procedure WebFormCreate(Sender: TObject);
    procedure cdsUsuariosAfterOpen(DataSet: TDataSet);
    procedure btnAlterarSenhaClick(Sender: TObject);
    procedure XDataClientAlterarSenhaError(Error: TXDataClientError);
    procedure XDataClientAlterarSenhaLoad(Response: TXDataClientResponse);
    procedure edtSenhaAtualClick(Sender: TObject);
    procedure edtNovaSenhaClick(Sender: TObject);
    procedure edtConfirmarSenhaClick(Sender: TObject);
    procedure btnChamarModalSenhaClick(Sender: TObject);
    procedure cdsUsuariosperfilGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure cdsUsuariosstatusGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);

    private
      function ValidarSenha : TArray<string>;
      procedure CriarCheckBoxServidores;
  protected procedure LoadDFMValues; override; end;

var
  FViewUserProfile: TFViewUserProfile;

implementation

uses
  JS,
  Auth.Service,
  ConnectionModule;

{$R *.dfm}

procedure TFViewUserProfile.btnChamarModalSenhaClick(Sender: TObject);
begin
  edtSenhaAtual.Text := '';
  edtNovaSenha.Text := '';
  edtConfirmarSenha.Text := '';
end;

procedure TFViewUserProfile.cdsUsuariosAfterOpen(DataSet: TDataSet);
begin
  CriarCheckBoxServidores;
end;

procedure TFViewUserProfile.cdsUsuariosperfilGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  case StrToInt(Sender.AsString) of
    1: Text := 'Fácil Sistemas';
    2: Text := 'Parceiro';
    3: Text := 'Aliado';
  end;
end;

procedure TFViewUserProfile.cdsUsuariosstatusGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  case StrToInt(Sender.AsString) of
    1: Text := 'Ativo';
    2: Text := 'Inativo/Bloqueado';
    3: Text := 'Aguardando validação';
  end;
end;

procedure TFViewUserProfile.CriarCheckBoxServidores;
const
  cPrefixoCheckBoxServidores = 'cbx_servidores_';
var
  lListaServidores : string;
  lServidoresAliado : TArray<string>;
  lIndice : Integer;
  lIdCheckBox,
  lIdLabel,
  lDivCriadaHtml : string;
begin
  lListaServidores := cdsUsuarios.FieldByName('perfil_acesso').AsString;

  if lListaServidores = '99' then
    lListaServidores := '1|2|3';

  lServidoresAliado := SplitString(lListaServidores, '|');

  for lIndice := Low(lServidoresAliado) to High(lServidoresAliado) do
  begin
    lIdCheckBox := cPrefixoCheckBoxServidores + lServidoresAliado[lIndice];
    lIdLabel := 'lbl_servidor_' + lServidoresAliado[lIndice];
    lDivCriadaHtml := '<div class="form-check"><input class="form-check-input" '+
    'type="checkbox" checked disabled value="'+lServidoresAliado[lIndice]+'" id="'+lIdCheckBox+'"/><label class="form-check-label" id="'+
      lIdLabel+'" for="'+lIdCheckBox+'">'+ TUtils.FServidoresDisponiveis[StrToInt(lServidoresAliado[lIndice]) - 1]+'</label></div>';

    divCheckBoxServidores.HTML.Add(lDivCriadaHtml);
  end;
end;

procedure TFViewUserProfile.edtConfirmarSenhaClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_dados_form_lbconfirmarsenha');
end;

procedure TFViewUserProfile.edtNovaSenhaClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_dados_form_lbnovasenha');
end;

procedure TFViewUserProfile.edtSenhaAtualClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_dados_form_lbsenhaatual');
end;

function TFViewUserProfile.ValidarSenha: TArray<string>;
begin
  TUtils.LimparErrosClass;

  SetLength(Result, 2);
  Result[0] := '';
  Result[1] := 'view_dados_form_lbsenhaatual';

  if Trim(edtSenhaAtual.Text) = '' then
  begin
    Result[0] := 'Senha atual não pode ser vazia!';
    Result[1] := 'view_dados_form_lbsenhaatual';
  end
  else if Length(Trim(edtSenhaAtual.Text)) < 6 then
  begin
    Result[0] := 'Senha atual deve ter no mínimo 6 caracteres!';
    Result[1] := 'view_dados_form_lbsenhaatual';
  end
  else if Trim(edtNovaSenha.Text) = '' then
  begin
    Result[0] := 'Nova senha não pode ser vazia!';
    Result[1] := 'view_dados_form_lbnovasenha';
  end
  else if Length(Trim(edtNovaSenha.Text)) < 6 then
  begin
    Result[0] := 'Nova senha deve ter no mínimo 6 caracteres!';
    Result[1] := 'view_dados_form_lbnovasenha';
  end
  else if Trim(edtConfirmarSenha.Text) = '' then
  begin
    Result[0] := 'Senha de confirmação não pode ser vazia!';
    Result[1] := 'view_dados_form_lbconfirmarsenha';
  end
  else if Length(Trim(edtConfirmarSenha.Text)) < 6 then
  begin
    Result[0] := 'Senha de confirmação deve ter no mínimo 6 caracteres!';
    Result[1] := 'view_dados_form_lbconfirmarsenha';
  end
  else if edtNovaSenha.Text <> edtConfirmarSenha.Text then
  begin
    Result[0] := 'Senha de confirmação se difere da nova senha!';
    Result[1] := 'view_dados_form_lbconfirmarsenha';
  end;
end;

procedure TFViewUserProfile.btnAlterarSenhaClick(Sender: TObject);
var
  lJson : TJSObject;
  lErro : TArray<string>;
begin
  lErro := ValidarSenha;

  if lErro[0] <> '' then
  begin
    TUtils.SetErroClass(lErro[1], lErro[0]);

    Exit;
  end;

  TUtils.ChamarDivLoading;

  lJson := TJSObject.New;
  lJson['senha_atual'] := edtSenhaAtual.Text;
  lJson['nova_senha'] := edtNovaSenha.Text;

  XDataClientAlterarSenha.RawInvoke('IService.AtualizarSenha', [lJson]);
end;

procedure TFViewUserProfile.WebFormCreate(Sender: TObject);
var
  lId : Integer;
begin
  lId := TUtils.FUsuario.Id;
  cdsUsuarios.QueryString := '$filter=(id eq ' + lId.ToString +')';
  cdsUsuarios.Load;
end;

procedure TFViewUserProfile.XDataClientAlterarSenhaError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewUserProfile.XDataClientAlterarSenhaLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Senha atualizada com sucesso!');

  asm
    $('#modal_atualizar_senha').modal('hide');
  end;
end;

procedure TFViewUserProfile.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create('view.userprofile.title');
  lbid := TLabel.Create('view.usuarios.form.lbid');
  lbnome := TLabel.Create('view.usuarios.form.lbnome');
  lbemail := TLabel.Create('view.usuarios.form.lbemail');
  lbultimo_acesso := TLabel.Create('view.usuarios.form.lbultimo_acesso');
  lbinclusao := TLabel.Create('view.usuarios.form.lbinclusao');
  lbalteracao := TLabel.Create('view.usuarios.form.lbalteracao');
  lbperfil := TLabel.Create('view.usuarios.form.lbperfil');
  lbstatus := TLabel.Create('view.usuarios.form.lbstatus');
  lblSenhaAtual := TLabel.Create('lblSenhaAtual');
  lblNovaSenha := TLabel.Create('lblNovaSenha');
  lblConfirmarSenha := TLabel.Create('lblConfirmarSenha');
  edid := TDBEdit.Create('view.usuarios.form.edid');
  ednome := TDBEdit.Create('view.usuarios.form.ednome');
  edemail := TDBEdit.Create('view.usuarios.form.edemail');
  edultimo_acesso := TDBEdit.Create('view.usuarios.form.edultimo_acesso');
  edinclusao := TDBEdit.Create('view.usuarios.form.edinclusao');
  edalteracao := TDBEdit.Create('view.usuarios.form.edalteracao');
  edperfil := TDBEdit.Create('view.usuarios.form.edperfil');
  edstatus := TDBEdit.Create('view.usuarios.form.edstatus');
  edtSenhaAtual := TEdit.Create('edtSenhaAtual');
  edtNovaSenha := TEdit.Create('edtNovaSenha');
  edtConfirmarSenha := TEdit.Create('edtConfirmarSenha');
  btnAlterarSenha := TButton.Create('btnAlterarSenha');
  btnChamarModalSenha := TButton.Create('btnChamarModalSenha');
  divCheckBoxServidores := THTMLDiv.Create('divCheckBoxServidores');
  cdsUsuarios := TXDataWebDataSet.Create(Self);
  cdsUsuariosid := TIntegerField.Create(Self);
  cdsUsuariosperfil := TIntegerField.Create(Self);
  cdsUsuariosperfil_acesso := TStringField.Create(Self);
  cdsUsuariosnome := TStringField.Create(Self);
  cdsUsuariosemail := TStringField.Create(Self);
  cdsUsuariosstatus := TIntegerField.Create(Self);
  cdsUsuariosultimo_acesso := TDateTimeField.Create(Self);
  cdsUsuariosinclusao := TDateTimeField.Create(Self);
  cdsUsuariosalteracao := TDateTimeField.Create(Self);
  dtsUsuarios := TDataSource.Create(Self);
  XDataClientAlterarSenha := TXDataWebClient.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbemail.BeforeLoadDFMValues;
  lbultimo_acesso.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbperfil.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  lblSenhaAtual.BeforeLoadDFMValues;
  lblNovaSenha.BeforeLoadDFMValues;
  lblConfirmarSenha.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edemail.BeforeLoadDFMValues;
  edultimo_acesso.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edperfil.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  edtSenhaAtual.BeforeLoadDFMValues;
  edtNovaSenha.BeforeLoadDFMValues;
  edtConfirmarSenha.BeforeLoadDFMValues;
  btnAlterarSenha.BeforeLoadDFMValues;
  btnChamarModalSenha.BeforeLoadDFMValues;
  divCheckBoxServidores.BeforeLoadDFMValues;
  cdsUsuarios.BeforeLoadDFMValues;
  cdsUsuariosid.BeforeLoadDFMValues;
  cdsUsuariosperfil.BeforeLoadDFMValues;
  cdsUsuariosperfil_acesso.BeforeLoadDFMValues;
  cdsUsuariosnome.BeforeLoadDFMValues;
  cdsUsuariosemail.BeforeLoadDFMValues;
  cdsUsuariosstatus.BeforeLoadDFMValues;
  cdsUsuariosultimo_acesso.BeforeLoadDFMValues;
  cdsUsuariosinclusao.BeforeLoadDFMValues;
  cdsUsuariosalteracao.BeforeLoadDFMValues;
  dtsUsuarios.BeforeLoadDFMValues;
  XDataClientAlterarSenha.BeforeLoadDFMValues;
  try
    Name := 'FViewUserProfile';
    Width := 604;
    Height := 434;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 520;
    WebLabel1.Top := 8;
    WebLabel1.Width := 58;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Meus Dados';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 8;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 37;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbemail.SetParentComponent(Self);
    lbemail.Name := 'lbemail';
    lbemail.Left := 24;
    lbemail.Top := 64;
    lbemail.Width := 28;
    lbemail.Height := 13;
    lbemail.Caption := 'Email:';
    lbemail.HeightPercent := 100.000000000000000000;
    lbemail.WidthPercent := 100.000000000000000000;
    lbultimo_acesso.SetParentComponent(Self);
    lbultimo_acesso.Name := 'lbultimo_acesso';
    lbultimo_acesso.Left := 199;
    lbultimo_acesso.Top := 8;
    lbultimo_acesso.Width := 70;
    lbultimo_acesso.Height := 13;
    lbultimo_acesso.Caption := #218'ltimo Acesso:';
    lbultimo_acesso.HeightPercent := 100.000000000000000000;
    lbultimo_acesso.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 199;
    lbinclusao.Top := 35;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 199;
    lbalteracao.Top := 62;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbperfil.SetParentComponent(Self);
    lbperfil.Name := 'lbperfil';
    lbperfil.Left := 24;
    lbperfil.Top := 91;
    lbperfil.Width := 28;
    lbperfil.Height := 13;
    lbperfil.Caption := 'Perfil:';
    lbperfil.HeightPercent := 100.000000000000000000;
    lbperfil.WidthPercent := 100.000000000000000000;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 221;
    lbstatus.Top := 89;
    lbstatus.Width := 35;
    lbstatus.Height := 13;
    lbstatus.Caption := 'Status:';
    lbstatus.HeightPercent := 100.000000000000000000;
    lbstatus.WidthPercent := 100.000000000000000000;
    lblSenhaAtual.SetParentComponent(Self);
    lblSenhaAtual.Name := 'lblSenhaAtual';
    lblSenhaAtual.Left := 1;
    lblSenhaAtual.Top := 120;
    lblSenhaAtual.Width := 62;
    lblSenhaAtual.Height := 13;
    lblSenhaAtual.Caption := 'Senha Atual:';
    lblSenhaAtual.HeightPercent := 100.000000000000000000;
    lblSenhaAtual.WidthPercent := 100.000000000000000000;
    lblNovaSenha.SetParentComponent(Self);
    lblNovaSenha.Name := 'lblNovaSenha';
    lblNovaSenha.Left := 1;
    lblNovaSenha.Top := 148;
    lblNovaSenha.Width := 62;
    lblNovaSenha.Height := 13;
    lblNovaSenha.Caption := 'Nova Senha:';
    lblNovaSenha.HeightPercent := 100.000000000000000000;
    lblNovaSenha.WidthPercent := 100.000000000000000000;
    lblConfirmarSenha.SetParentComponent(Self);
    lblConfirmarSenha.Name := 'lblConfirmarSenha';
    lblConfirmarSenha.Left := 184;
    lblConfirmarSenha.Top := 120;
    lblConfirmarSenha.Width := 84;
    lblConfirmarSenha.Height := 13;
    lblConfirmarSenha.Caption := 'Confirmar Senha:';
    lblConfirmarSenha.HeightPercent := 100.000000000000000000;
    lblConfirmarSenha.WidthPercent := 100.000000000000000000;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 69;
    edid.Top := 5;
    edid.Width := 108;
    edid.Height := 21;
    edid.ChildOrder := 6;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := dtsUsuarios;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 69;
    ednome.Top := 34;
    ednome.Width := 108;
    ednome.Height := 21;
    ednome.ChildOrder := 8;
    ednome.Enabled := False;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.TabOrder := 1;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    ednome.DataField := 'nome';
    ednome.DataSource := dtsUsuarios;
    edemail.SetParentComponent(Self);
    edemail.Name := 'edemail';
    edemail.Left := 69;
    edemail.Top := 61;
    edemail.Width := 108;
    edemail.Height := 21;
    edemail.ChildOrder := 10;
    edemail.Enabled := False;
    edemail.HeightPercent := 100.000000000000000000;
    edemail.TabOrder := 2;
    edemail.Text := 'edemail';
    edemail.WidthPercent := 100.000000000000000000;
    edemail.DataField := 'email';
    edemail.DataSource := dtsUsuarios;
    edultimo_acesso.SetParentComponent(Self);
    edultimo_acesso.Name := 'edultimo_acesso';
    edultimo_acesso.Left := 273;
    edultimo_acesso.Top := 5;
    edultimo_acesso.Width := 100;
    edultimo_acesso.Height := 21;
    edultimo_acesso.ChildOrder := 3;
    edultimo_acesso.Enabled := False;
    edultimo_acesso.HeightPercent := 100.000000000000000000;
    edultimo_acesso.TabOrder := 14;
    edultimo_acesso.Text := 'edultimo_acesso';
    edultimo_acesso.WidthPercent := 100.000000000000000000;
    edultimo_acesso.DataField := 'ultimo_acesso';
    edultimo_acesso.DataSource := dtsUsuarios;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 274;
    edinclusao.Top := 32;
    edinclusao.Width := 100;
    edinclusao.Height := 21;
    edinclusao.ChildOrder := 4;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 15;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := dtsUsuarios;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 274;
    edalteracao.Top := 59;
    edalteracao.Width := 100;
    edalteracao.Height := 21;
    edalteracao.ChildOrder := 5;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 16;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := dtsUsuarios;
    edperfil.SetParentComponent(Self);
    edperfil.Name := 'edperfil';
    edperfil.Left := 69;
    edperfil.Top := 88;
    edperfil.Width := 108;
    edperfil.Height := 21;
    edperfil.ChildOrder := 10;
    edperfil.Enabled := False;
    edperfil.HeightPercent := 100.000000000000000000;
    edperfil.TabOrder := 2;
    edperfil.Text := 'edperfil';
    edperfil.WidthPercent := 100.000000000000000000;
    edperfil.DataField := 'perfil';
    edperfil.DataSource := dtsUsuarios;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 274;
    edstatus.Top := 86;
    edstatus.Width := 100;
    edstatus.Height := 21;
    edstatus.ChildOrder := 10;
    edstatus.Enabled := False;
    edstatus.HeightPercent := 100.000000000000000000;
    edstatus.TabOrder := 2;
    edstatus.Text := 'edstatus';
    edstatus.WidthPercent := 100.000000000000000000;
    edstatus.DataField := 'status';
    edstatus.DataSource := dtsUsuarios;
    edtSenhaAtual.SetParentComponent(Self);
    edtSenhaAtual.Name := 'edtSenhaAtual';
    edtSenhaAtual.Left := 69;
    edtSenhaAtual.Top := 117;
    edtSenhaAtual.Width := 108;
    edtSenhaAtual.Height := 22;
    edtSenhaAtual.ChildOrder := 17;
    edtSenhaAtual.HeightPercent := 100.000000000000000000;
    edtSenhaAtual.WidthPercent := 100.000000000000000000;
    SetEvent(edtSenhaAtual, Self, 'OnClick', 'edtSenhaAtualClick');
    edtNovaSenha.SetParentComponent(Self);
    edtNovaSenha.Name := 'edtNovaSenha';
    edtNovaSenha.Left := 69;
    edtNovaSenha.Top := 145;
    edtNovaSenha.Width := 108;
    edtNovaSenha.Height := 22;
    edtNovaSenha.ChildOrder := 17;
    edtNovaSenha.HeightPercent := 100.000000000000000000;
    edtNovaSenha.WidthPercent := 100.000000000000000000;
    SetEvent(edtNovaSenha, Self, 'OnClick', 'edtNovaSenhaClick');
    edtConfirmarSenha.SetParentComponent(Self);
    edtConfirmarSenha.Name := 'edtConfirmarSenha';
    edtConfirmarSenha.Left := 274;
    edtConfirmarSenha.Top := 117;
    edtConfirmarSenha.Width := 100;
    edtConfirmarSenha.Height := 22;
    edtConfirmarSenha.ChildOrder := 17;
    edtConfirmarSenha.HeightPercent := 100.000000000000000000;
    edtConfirmarSenha.WidthPercent := 100.000000000000000000;
    SetEvent(edtConfirmarSenha, Self, 'OnClick', 'edtConfirmarSenhaClick');
    btnAlterarSenha.SetParentComponent(Self);
    btnAlterarSenha.Name := 'btnAlterarSenha';
    btnAlterarSenha.Left := 278;
    btnAlterarSenha.Top := 145;
    btnAlterarSenha.Width := 96;
    btnAlterarSenha.Height := 25;
    btnAlterarSenha.Caption := 'Salvar';
    btnAlterarSenha.ChildOrder := 23;
    btnAlterarSenha.HeightPercent := 100.000000000000000000;
    btnAlterarSenha.WidthPercent := 100.000000000000000000;
    SetEvent(btnAlterarSenha, Self, 'OnClick', 'btnAlterarSenhaClick');
    btnChamarModalSenha.SetParentComponent(Self);
    btnChamarModalSenha.Name := 'btnChamarModalSenha';
    btnChamarModalSenha.Left := 278;
    btnChamarModalSenha.Top := 176;
    btnChamarModalSenha.Width := 96;
    btnChamarModalSenha.Height := 25;
    btnChamarModalSenha.Caption := 'Alterar Senha';
    btnChamarModalSenha.ChildOrder := 24;
    btnChamarModalSenha.HeightPercent := 100.000000000000000000;
    btnChamarModalSenha.WidthPercent := 100.000000000000000000;
    SetEvent(btnChamarModalSenha, Self, 'OnClick', 'btnChamarModalSenhaClick');
    divCheckBoxServidores.SetParentComponent(Self);
    divCheckBoxServidores.Name := 'divCheckBoxServidores';
    divCheckBoxServidores.Left := 8;
    divCheckBoxServidores.Top := 189;
    divCheckBoxServidores.Width := 169;
    divCheckBoxServidores.Height := 41;
    divCheckBoxServidores.ChildOrder := 7;
    divCheckBoxServidores.Role := '';
    cdsUsuarios.SetParentComponent(Self);
    cdsUsuarios.Name := 'cdsUsuarios';
    cdsUsuarios.AfterOpen := cdsUsuariosAfterOpen;
    cdsUsuarios.EntitySetName := 'Usuarios_Gerenciamento';
    cdsUsuarios.Connection := DMConnection.ApiConnection;
    cdsUsuarios.QueryTop := 1;
    cdsUsuarios.Left := 256;
    cdsUsuarios.Top := 240;
    cdsUsuariosid.SetParentComponent(cdsUsuarios);
    cdsUsuariosid.Name := 'cdsUsuariosid';
    cdsUsuariosid.FieldName := 'id';
    cdsUsuariosid.Required := True;
    cdsUsuariosperfil.SetParentComponent(cdsUsuarios);
    cdsUsuariosperfil.Name := 'cdsUsuariosperfil';
    cdsUsuariosperfil.FieldName := 'perfil';
    cdsUsuariosperfil.Required := True;
    SetEvent(cdsUsuariosperfil, Self, 'OnGetText', 'cdsUsuariosperfilGetText');
    cdsUsuariosperfil_acesso.SetParentComponent(cdsUsuarios);
    cdsUsuariosperfil_acesso.Name := 'cdsUsuariosperfil_acesso';
    cdsUsuariosperfil_acesso.FieldName := 'perfil_acesso';
    cdsUsuariosperfil_acesso.Size := 255;
    cdsUsuariosnome.SetParentComponent(cdsUsuarios);
    cdsUsuariosnome.Name := 'cdsUsuariosnome';
    cdsUsuariosnome.FieldName := 'nome';
    cdsUsuariosnome.Required := True;
    cdsUsuariosnome.Size := 255;
    cdsUsuariosemail.SetParentComponent(cdsUsuarios);
    cdsUsuariosemail.Name := 'cdsUsuariosemail';
    cdsUsuariosemail.FieldName := 'email';
    cdsUsuariosemail.Required := True;
    cdsUsuariosemail.Size := 255;
    cdsUsuariosstatus.SetParentComponent(cdsUsuarios);
    cdsUsuariosstatus.Name := 'cdsUsuariosstatus';
    cdsUsuariosstatus.FieldName := 'status';
    cdsUsuariosstatus.Required := True;
    SetEvent(cdsUsuariosstatus, Self, 'OnGetText', 'cdsUsuariosstatusGetText');
    cdsUsuariosultimo_acesso.SetParentComponent(cdsUsuarios);
    cdsUsuariosultimo_acesso.Name := 'cdsUsuariosultimo_acesso';
    cdsUsuariosultimo_acesso.FieldName := 'ultimo_acesso';
    cdsUsuariosultimo_acesso.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsUsuariosinclusao.SetParentComponent(cdsUsuarios);
    cdsUsuariosinclusao.Name := 'cdsUsuariosinclusao';
    cdsUsuariosinclusao.FieldName := 'inclusao';
    cdsUsuariosinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsUsuariosalteracao.SetParentComponent(cdsUsuarios);
    cdsUsuariosalteracao.Name := 'cdsUsuariosalteracao';
    cdsUsuariosalteracao.FieldName := 'alteracao';
    cdsUsuariosalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    dtsUsuarios.SetParentComponent(Self);
    dtsUsuarios.Name := 'dtsUsuarios';
    dtsUsuarios.DataSet := cdsUsuarios;
    dtsUsuarios.Left := 376;
    dtsUsuarios.Top := 272;
    XDataClientAlterarSenha.SetParentComponent(Self);
    XDataClientAlterarSenha.Name := 'XDataClientAlterarSenha';
    XDataClientAlterarSenha.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientAlterarSenha, Self, 'OnLoad', 'XDataClientAlterarSenhaLoad');
    SetEvent(XDataClientAlterarSenha, Self, 'OnError', 'XDataClientAlterarSenhaError');
    XDataClientAlterarSenha.Left := 480;
    XDataClientAlterarSenha.Top := 240;
  finally
    WebLabel1.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbemail.AfterLoadDFMValues;
    lbultimo_acesso.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbperfil.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    lblSenhaAtual.AfterLoadDFMValues;
    lblNovaSenha.AfterLoadDFMValues;
    lblConfirmarSenha.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edemail.AfterLoadDFMValues;
    edultimo_acesso.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edperfil.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    edtSenhaAtual.AfterLoadDFMValues;
    edtNovaSenha.AfterLoadDFMValues;
    edtConfirmarSenha.AfterLoadDFMValues;
    btnAlterarSenha.AfterLoadDFMValues;
    btnChamarModalSenha.AfterLoadDFMValues;
    divCheckBoxServidores.AfterLoadDFMValues;
    cdsUsuarios.AfterLoadDFMValues;
    cdsUsuariosid.AfterLoadDFMValues;
    cdsUsuariosperfil.AfterLoadDFMValues;
    cdsUsuariosperfil_acesso.AfterLoadDFMValues;
    cdsUsuariosnome.AfterLoadDFMValues;
    cdsUsuariosemail.AfterLoadDFMValues;
    cdsUsuariosstatus.AfterLoadDFMValues;
    cdsUsuariosultimo_acesso.AfterLoadDFMValues;
    cdsUsuariosinclusao.AfterLoadDFMValues;
    cdsUsuariosalteracao.AfterLoadDFMValues;
    dtsUsuarios.AfterLoadDFMValues;
    XDataClientAlterarSenha.AfterLoadDFMValues;
  end;
end;

end.
